import React from 'react'
import axios from 'axios'
import { Button, Image } from 'react-bootstrap'
import { getParams, end_point, applyOrganizationTheme } from './helper'

class OrganizationLandingPage extends React.Component {
  constructor(props) {
    super(props)
    const params = getParams()
    const organization_id = params.organization_id || localStorage.getItem('organization_id') || ''
    this.state = {
      organization_id,
      organization: null,
      loading: Boolean(organization_id),
      error: '',
    }
  }

  getLandingGradientStyle = (organization) => {
    const start = organization && organization.landing_page_gradient_start
      ? organization.landing_page_gradient_start
      : '#0f172a'
    const end = organization && organization.landing_page_gradient_end
      ? organization.landing_page_gradient_end
      : '#172033'
    return {
      '--landing-gradient-start': start,
      '--landing-gradient-end': end,
    }
  }

  componentDidMount() {
    const { organization_id } = this.state
    if (!organization_id) {
      this.setState({
        loading: false,
        error: 'Missing organization id for this landing page.',
      })
      return
    }

    localStorage.setItem('organization_id', organization_id)
    this.loadOrganization(organization_id)
  }

  getOrganizationDisplayName = (organization) => {
    if (!organization || typeof organization !== 'object') {
      return ''
    }

    const businessDetails = organization.business_details || {}
    return (
      organization.name ||
      businessDetails.business_name ||
      organization.dba_name ||
      organization.business_name ||
      ''
    )
  }

  loadOrganization = async (organizationId) => {
    try {
      const response = await axios.get(`${end_point('organizations')}/organizations`, {
        headers: {
          token: 'landing',
          organization_id: organizationId,
        },
      })

      let organization = response.data
      if (typeof organization === 'string') {
        try {
          organization = JSON.parse(organization)
        } catch (parseError) {
          organization = null
        }
      }

      if (organization && organization.body && typeof organization.body === 'string') {
        try {
          organization = JSON.parse(organization.body)
        } catch (parseError) {
          organization = organization.body
        }
      }

      if (organization && Array.isArray(organization)) {
        organization = organization[0]
      }

      if (organization && organization.message) {
        organization = organization.message
      }

      if (organization && organization.data) {
        organization = organization.data
          }

      const normalizedOrganization = organization && typeof organization === 'object'
        ? {
            ...organization,
            landing_page_hero_text: organization.landing_page_hero_text || '',
            landing_page_hero_subheading: organization.landing_page_hero_subheading || '',
            landing_page_gradient_start: organization.landing_page_gradient_start || '#0f172a',
            landing_page_gradient_end: organization.landing_page_gradient_end || '#172033',
          }
        : {
          _id: organizationId,
          name: '',
          logo: '',
          navbar_color: '#5563b8',
          navbar_text_color: '#ffffff',
          landing_page_hero_text: '',
          landing_page_hero_subheading: '',
          landing_page_gradient_start: '#0f172a',
          landing_page_gradient_end: '#172033',
          }

      if (!organization || typeof organization !== 'object') {
        console.warn('landing page loaded without organization config; using fallback shell')
      }

      this.setState({
        organization: normalizedOrganization,
        loading: false,
        error: '',
      })

      applyOrganizationTheme({
        navbar_color: normalizedOrganization.navbar_color,
        navbar_text_color: normalizedOrganization.navbar_text_color,
      })
    } catch (error) {
      console.error('landing page load failed', error)
      this.setState({
        loading: false,
        error: '',
          organization: {
          _id: organizationId,
          name: '',
          logo: '',
          navbar_color: '#5563b8',
          navbar_text_color: '#ffffff',
          landing_page_hero_text: '',
          landing_page_hero_subheading: '',
          landing_page_gradient_start: '#0f172a',
          landing_page_gradient_end: '#172033',
        },
      })
      applyOrganizationTheme({
        navbar_color: '#5563b8',
        navbar_text_color: '#ffffff',
      })
    }
  }

  getLoginUrl = () => {
    const { organization } = this.state
    const organizationId = this.state.organization_id
    const organizationName = this.getOrganizationDisplayName(organization) ? encodeURIComponent(this.getOrganizationDisplayName(organization)) : ''
    const nameParam = organizationName ? `&organization_name=${organizationName}` : ''
    const origin = typeof window !== 'undefined' ? window.location.origin : ''
    return `${origin}/login?organization_id=${organizationId}${nameParam}`
  }

  render() {
    const { organization, loading, error } = this.state
    const organizationName = this.getOrganizationDisplayName(organization) || 'Organization'
    const heroText = organization && organization.landing_page_hero_text
      ? organization.landing_page_hero_text
      : organizationName
    const heroSubheading = organization && organization.landing_page_hero_subheading
      ? organization.landing_page_hero_subheading
      : 'Sign in to view programs, manage your account, and continue registration.'
    const loginUrl = this.state.organization_id ? this.getLoginUrl() : '#'
    const landingStyle = this.getLandingGradientStyle(organization)
    return (
      <div className="landing-page-shell" style={landingStyle}>
        <div className="landing-page-backdrop" />
        <div className="landing-page-content">
          {loading ? (
            <div className="landing-page-loading">
              <div className="loader cent"></div>
            </div>
          ) : error ? (
            <div className="landing-page-error-card">
              <div className="landing-page-error-title">Landing page unavailable</div>
              <div className="landing-page-error-copy">{error}</div>
            </div>
          ) : (
            <>
              <div className="landing-page-grid">
                <div className="landing-page-copy-panel">
                  <div className="landing-page-kicker">Club Portal</div>
                  <h1 className="landing-page-title">{heroText}</h1>
                  <p className="landing-page-subheading">{heroSubheading}</p>
                <div className="landing-page-actions">
                  <Button
                    type="button"
                    className="modalbutton landing-page-login-btn"
                    onClick={() => { window.location.href = loginUrl }}
                    disabled={!organization}
                  >
                    Continue to Login
                  </Button>
                </div>
              </div>

                <div className="landing-page-visual-panel">
                  <div className="landing-page-visual-card">
                    <div className="landing-page-visual-header">
                      <div className="landing-page-visual-label">Club preview</div>
                      <div className="landing-page-visual-name">{organizationName}</div>
                    </div>
                    <div className="landing-page-logo-wrap">
                    {organization && organization.logo ? (
                        <Image src={organization.logo} className="landing-page-logo" />
                      ) : (
                        <div className="landing-page-logo-empty">{organizationName ? organizationName.charAt(0) : 'H'}</div>
                      )}
                    </div>
                    <div className="landing-page-visual-notes">
                      <div className="landing-page-visual-notes-label">Club notes</div>
                      <div className="landing-page-visual-notes-body">
                        {(organization && organization.description) ? organization.description : 'No club notes have been added yet.'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="landing-page-programs-section">
                <div className="landing-page-programs-shell dashboard-box programs-container">
                  <programs-api
                    id="landing-programslist"
                    filtered_program_ids={JSON.stringify([])}
                    organization_id={this.state.organization_id}
                    organization_name={organizationName}
                    grid_heading_background_color="var(--org-primary-color, #5563b8)"
                    grid_heading_font_color="var(--org-primary-text-color, #ffffff)"
                    grid_heading_selected_column_font_color="var(--org-primary-contrast-color, #ffffff)"
                    program_grid_selected_font_color="var(--org-primary-contrast-color, #ffffff)"
                    program_detail_header_background_color="var(--org-primary-color, #5563b8)"
                    program_detail_header_font_color="var(--org-primary-text-color, #ffffff)"
                    cta_link_analytics_override=""
                    cta_background_color="var(--org-primary-color, #5563b8)"
                    cta_font_color=""
                    cta_hover_border_color=""
                    cta_hover_background_color=""
                    cta_hover_font_color=""
                    master_detail_mode="false"
                    program_grid_selected_row_background_color="var(--org-primary-color, #5563b8)"
                    program_grid_selected_radio_button_color="var(--org-primary-text-color, #ffffff)"
                    program_grid_odd_row_background_color="#f8fafc"
                    program_grid_even_row_background_color="#ffffff"
                    program_grid_row_font_color="#404040"
                    program_grid_container_paddings="0"
                    readonly={false}
                    always_drop_down_filter_menu={true}
                    init_rows_expanded="false"
                    expand={false}
                    sticky_header={true}
                  ></programs-api>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    )
  }
}

export default OrganizationLandingPage
